import { createEvent, sample } from 'effector';
import { $categoryMapApi, $sceneMap } from '@stores/dataStores';
import { showConfirmModal } from '@components/ConfirmModal';

function mixSort(a: string, b: string) {
  const regNum = /^[0-9]*$/;
  const reg = /[a-zA-Z0-9]/;

  if (regNum.test(a) && regNum.test(b)) {
    return Number(a) - Number(b);
  }
  if (regNum.test(a) && !regNum.test(b)) {
    return -1;
  }
  if (!regNum.test(a) && regNum.test(b)) {
    return 1;
  }

  if (reg.test(a[0]) || reg.test(b[0])) {
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  }
  return a.localeCompare(b, 'zh-Hans-CN', { sensitivity: 'accent' });
}

export const sortSubCategoryScenes = createEvent<number>();
sample({
  source: $sceneMap,
  clock: sortSubCategoryScenes,
  fn: (sceneMap, subId) => ({ sceneMap, subId }),
}).watch(async ({ sceneMap, subId }) => {
  const { confirmed } = await showConfirmModal({
    title: '确认操作',
    content: (
      <div className="flex flex-col items-center">
        <div className="mb-10 text-lg">确认对当前分组下的场景进行排序？</div>
        <div>场景名称将按照先数字、其次英文字母、最后汉字拼音进行排序</div>
        <div>注意：一级分组排序将对其下所有二级分组内的场景分别排序</div>
      </div>
    ),
  });
  if (!confirmed) return;
  $categoryMapApi.update((draft) => {
    const category = draft.get(subId);
    if (!category) return;
    category.sceneIds.sort((a, b) => {
      const titleA = sceneMap.get(a)?.name ?? '';
      const titleB = sceneMap.get(b)?.name ?? '';
      return mixSort(titleA, titleB);
    });
  });
});

export const sortCategoryScenes = createEvent<number>();
sample({
  source: $sceneMap,
  clock: sortCategoryScenes,
  fn: (sceneMap, cateId) => ({ sceneMap, cateId }),
}).watch(async ({ sceneMap, cateId }) => {
  const { confirmed } = await showConfirmModal({
    title: '确认操作',
    content: (
      <div className="flex flex-col items-center">
        <div className="mb-10 text-xl">确认对当前分组下的场景进行排序？</div>
        <div>场景名称将按照先数字、其次英文字母、最后汉字拼音进行排序</div>
        <div>注意：一级分组排序将对其下所有二级分组内的场景分别排序</div>
      </div>
    ),
  });
  if (!confirmed) return;
  $categoryMapApi.update((draft) => {
    const category = draft.get(cateId);
    if (!category) return;
    if (category.categoryIds.length === 0) {
      category.sceneIds.sort((a, b) => {
        const titleA = sceneMap.get(a)?.name ?? '';
        const titleB = sceneMap.get(b)?.name ?? '';
        return mixSort(titleA, titleB);
      });
    } else {
      category.categoryIds.forEach((subId) => {
        const subCategory = draft.get(subId);
        if (!subCategory) return;
        subCategory.sceneIds.sort((a, b) => {
          const titleA = sceneMap.get(a)?.name ?? '';
          const titleB = sceneMap.get(b)?.name ?? '';
          return mixSort(titleA, titleB);
        });
      });
    }
  });
});
